import { IoDiamondOutline } from "react-icons/io5";
import { Button, Form, Alert,Row, Col, Container, Card, } from 'react-bootstrap';
export const RenderHeader = () => {

  return (
      <Container>
        <Row>
          <Col style={{textAlign: "center"}}>
          
            <Card style={{border:"0px"}}>
              <Card.Body>
                <h3><IoDiamondOutline />&nbsp;Gem City Jobs</h3>
              </Card.Body>
            </Card>
            
          </Col>
        </Row>
      </Container>
  )
}